import AdminLayout from '../../components/admin-layout';
import EditUser from "../user-edit";

export default function Profile() {
  return (
    <AdminLayout>
      <EditUser />
    </AdminLayout>
  );
}

